import React from "react";

const RefundExchangePolicy = () => {
  return (
    <div className="px-6 mt-27 py-12 max-w-5xl mx-auto text-black bg-white">
      <h1 className="text-3xl font-bold mb-6 text-center">
        Refund & Exchange Policy
      </h1>

      <p className="mb-4">
        At The Great Honey Co., we take pride in delivering pure, high-quality honey and honey-based products to our customers.
        Due to the perishable nature of our products, we currently offer exchanges only and do not provide refunds or returns.
      </p>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Exchange Eligibility</h2>
      <p className="mb-4">
        We will happily offer a product exchange in the event of:
      </p>
      <ul className="list-disc ml-6 mb-6 space-y-2">
        <li>Damaged or Incorrect Products: If your order arrives damaged or incorrect, please contact us within 24 hours of receiving the package.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-8 mb-4">How to Request an Exchange</h2>
      <ol className="list-decimal ml-6 mb-6 space-y-2">
        <li>Take clear videos and photos of the product, ensuring it remains unopened with all original packaging intact.</li>
        <li>Email the images and a brief description of the issue to <a className="underline" href="mailto:hello@thegreathoneyco.com">hello@thegreathoneyco.com</a> within 1 day of receiving your order.</li>
        <li>Our team will review your request and, if eligible, arrange for an exchange.</li>
      </ol>

      <h2 className="text-2xl font-semibold mt-8 mb-4">Additional Information</h2>
      <ul className="list-disc ml-6 space-y-2">
        <li>Exchanges will only be processed once our team has reviewed and confirmed that the product meets the above criteria.</li>
        <li>We do not accept returns for reasons such as change of mind or personal preference.</li>
        <li>For further assistance, feel free to reach out at <a className="underline" href="mailto:hello@thegreathoneyco.com">hello@thegreathoneyco.com</a> or call us at 863-954-2319.</li>
      </ul>

      <p className="mt-6">
        Thank you for choosing The Great Honey Co. – where quality and customer satisfaction come first! 🍯🐝
      </p>
    </div>
  );
};

export default RefundExchangePolicy;
